import { useEffect } from "react";

import AllowGrey from "./assets/trade/arrow_grey.png";
import FaviconFooter from "./assets/trade/favicon-footer.png";
import Logo from "./assets/trade/logo.png";
import Facebook from "./assets/trade/social/facebook.png";
import Instagram from "./assets/trade/social/inst.png";
import Twitch from "./assets/trade/social/twitch.png";
import Twitter from "./assets/trade/social/twitter.png";
import Youtube from "./assets/trade/social/youtube.png";
import File1 from "./assets/trade/trade/file1.png";
import File2 from "./assets/trade/trade/file2.png";
import File3 from "./assets/trade/trade/file3.png";
import File4 from "./assets/trade/trade/file4.png";
import File5 from "./assets/trade/trade/file5.png";

import { useNavigate } from "react-router-dom";
import { useT } from "./router/Router";
import "./styles/TradePage.scss";

const TradePage = () => {
    const navigate = useNavigate();
    const t = useT();

    useEffect(() => {
        let header = document.querySelector("header");
        window.addEventListener("scroll", () => {
            if (!header) return;

            if (window.scrollY > 100) header.classList.add("bg__dark");
            if (window.scrollY < 100) header.classList.remove("bg__dark");
        });
    }, []);

    return (
        <div className="trade">
            <header>
                <div className="container">
                    <div className="wrapper">
                        <div className="logo__wrapper">
                            <a className="logo">
                                <img src={Logo} alt="LOGO" />
                            </a>
                        </div>

                        <nav className="navigation">
                            <ul>
                                <li>
                                    <a href="#last" className="btn__orange">
                                        {t("check_out_now")}
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </header>

            <section>
                <div className="container">
                    <div className="wrapper">
                        <div className="wrapper__img">
                            <img src={Logo} alt="VERIF STARS" />
                            <div className="block__title">
                                <h2>{t("trade_title")}</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="line">
                <span></span>
            </div>

            <section className="screenshot" id="last">
                <div className="container">
                    <div className="wrapper">
                        <div className="block__trade" id="img__1">
                            <p>
                                {t("step_1")}. {t("step_1_text")}
                            </p>
                            <div className="block__img">
                                <a href="#img__2">
                                    <img src={File1} alt="STEP TRADE" />
                                </a>
                            </div>
                            <div className="block__arrow">
                                <img src={AllowGrey} alt="arrow grey" />
                            </div>
                        </div>
                        <div className="block__trade" id="img__2">
                            <p>
                                {t("step_2")}: {t("step_2_text")}
                            </p>
                            <div className="block__img">
                                <a href="#img__3">
                                    <img src={File2} alt="STEP TRADE" />
                                </a>
                            </div>
                            <div className="block__arrow">
                                <img src={AllowGrey} alt="arrow grey" />
                            </div>
                        </div>
                        <div className="block__trade" id="img__3">
                            <p>
                                {t("step_3")}. {t("step_3_text")}
                            </p>
                            <div className="block__img">
                                <a href="#img__4">
                                    <img src={File3} alt="STEP TRADE" />
                                </a>
                            </div>
                            <div className="block__arrow">
                                <img src={AllowGrey} alt="arrow grey" />
                            </div>
                        </div>
                        <div className="block__trade" id="img__4">
                            <p>
                                {t("step_4")} -{t("step_4_text")}
                            </p>
                            <div className="block__img">
                                <a href="#img__5">
                                    <img src={File4} alt="STEP TRADE" />
                                </a>
                            </div>
                            <div className="block__arrow">
                                <img src={AllowGrey} alt="arrow grey" />
                            </div>
                        </div>
                        <div className="block__trade" id="img__5">
                            <p>
                                {t("step_5")}. {t("step_5_text")}
                            </p>
                            <div className="block__img">
                                <a href="#img__6">
                                    <img src={File5} alt="STEP TRADE" />
                                </a>
                            </div>
                            <div className="block__arrow">
                                <img src={AllowGrey} alt="arrow grey" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="buttons" id="last">
                <div className="container">
                    <div className="wrapper">
                        <div className="text__footer">
                            <p className="text__main">{t("bottom_text_1")}</p>
                            <p className="text__second">{t("bottom_text_2")}</p>
                        </div>

                        <div className="block__btn">
                            <a
                                className="btn__orange trigger__modal"
                                onClick={() => navigate("/join")}
                            >
                                {t("understand")}
                            </a>

                            <div className="btn__grey">
                                <a href="https://blog.faceit.com/introducing-the-faceit-id-verification-system-an-unmatched-layer-of-security-to-create-a-more-c3232fdba781">
                                    {t("read_blog")}
                                </a>
                            </div>

                            <div className="btn__grey">
                                <a href="https://support.faceit.com/hc/en-us/articles/8650124346780-Verification-FAQ">
                                    {t("preview_faqs")}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="line">
                <span></span>
            </div>

            <footer>
                <div className="container">
                    <div className="wrapper">
                        <div className="block__flex__footer">
                            <div className="logo">
                                <img src={FaviconFooter} alt="LOGO" />
                            </div>

                            <div className="nav__anchor nav">
                                <a href="#verify">{t("why_verify_account")}</a>
                                <a href="#how">{t("how_verify_account")}</a>
                            </div>

                            <div className="nav__link nav">
                                <a>{t("privacy_policy")}</a>
                                <a>{t("cookie_settings")}</a>
                                <a>{t("rules")}</a>
                                <a>©FACEIT 2025</a>
                            </div>

                            <div className="social">
                                <a>
                                    <img src={Twitter} alt="twitter" />
                                </a>
                                <a>
                                    <img src={Instagram} alt="inst" />
                                </a>
                                <a>
                                    <img src={Twitch} alt="twitch" />
                                </a>
                                <a>
                                    <img src={Facebook} alt="facebook" />
                                </a>
                                <a>
                                    <img src={Youtube} alt="youtube" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default TradePage;
